var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6011 14.6007C17.2692 14.9326 16.731 14.9326 16.3991 14.6007L12.0001 10.2017L7.60114 14.6006C7.26919 14.9326 6.731 14.9326 6.39906 14.6006C6.06711 14.2687 6.06711 13.7305 6.39906 13.3986L11.3991 8.39857C11.731 8.06662 12.2692 8.06662 12.6011 8.39857L17.6011 13.3986C17.9331 13.7305 17.9331 14.2687 17.6011 14.6007Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.d51eced4c920bee415996c3fbb052143.svg";
export { ForwardRef as ReactComponent };